import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <defs key='0'>
      <clipPath id='transportMarkerSquareClip'>
        <path id='transportMarkerSquareShape' d='M4 4L18 4L18 18L4 18L4 4Z' />
      </clipPath>
    </defs>,
    <use key='1' xlinkHref='#transportMarkerSquareShape' fill='none' stroke='#000000' />,
    <use key='2' xlinkHref='#transportMarkerSquareShape' stroke='#ffffff' clipPath='url(#transportMarkerSquareClip)' />,
  ],
  'TransportMarkerSquare'
);

const TransportMarkerSquareIcon = function (props) {
  return (
    <SvgIcon
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      sx={{
        'path:nth-of-type(3)': {
          fill: props.htmlColor,
        },
      }}
      {...props}
    />
  );
};

export default memo(TransportMarkerSquareIcon);
